import { Icon, Pill, PillWrapper } from "@theorgchartdev/storybook";
import { BoxChip } from "@/Utils/BoxChip";
import { GetDoc } from "@/Utils/StateLib";
import { enumObjectTypes } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { isNullish } from "@theorgchartdev/storybook";

export const ConflictRecordChip = ({ dbObj, override, onClick, disabled = false }) => {
  const doc = GetDoc();
  if (!doc || !override) return null;

  const objType = override.SmartGetFieldValue("objType") ?? enumObjectTypes.holder;
  const recordId = override.SmartGetFieldValue("RefID");
  const isPosition = objType === enumObjectTypes.position;

  let label;

  if (isNullish(dbObj)) {
    label = `${appstr("Blank")} (${recordId})`;
  } else if (isPosition) {
    const chipObject = BoxChip.FromPositionObjDBObject(dbObj);
    label = chipObject.label();
  } else {
    const chipObject = BoxChip.FromEmployeeObjDBObject(dbObj);
    label = chipObject.label();
  }

  const iconName = isPosition ? "cubes" : "image-user";

  const pill = (
    <PillWrapper>
      <Pill
        className="oc-relative"
        label={label}
        disabled={disabled}
        leftContent={<Icon name={iconName} size="small" />}
      />
    </PillWrapper>
  );

  if (!disabled && onClick) {
    return (
      <span
        className="oc-conflict-record-chip--clickable"
        data-testid="planning-changes-conflict-record-chip"
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            onClick();
          }
        }}
      >
        {pill}
      </span>
    );
  }

  return pill;
};
